import React from "react";
import { useFormik } from "formik";
import { getDayDocumentsInit, setDayDocumentsInit } from "../../services/configuration.service.ts";
import { notification } from "../../utils/Notifications.tsx";

interface IEditDayDocumentsInit {
  setLoading: (value: boolean) => void;
  closeFn: () => void;
  refreshFn: () => void;
  currentDate?: string | null;
}

const EditDayDocumentsInit: React.FC<IEditDayDocumentsInit> = ({
  setLoading,
  closeFn,
  refreshFn,
  currentDate,
}) => {
  const [initialDate, setInitialDate] = React.useState<string>("");

  React.useEffect(() => {
    const fetchDate = async () => {
      try {
        const dateStr = await getDayDocumentsInit();
        if (dateStr) {
          const date = new Date(dateStr);
          const formattedDate = date.toISOString().split("T")[0];
          setInitialDate(formattedDate);
        } else if (currentDate) {
          setInitialDate(currentDate);
        }
      } catch (error) {
        console.error("Error al obtener día inicio documentos:", error);
        if (currentDate) {
          setInitialDate(currentDate);
        }
      }
    };

    fetchDate();
  }, [currentDate]);

  const formik = useFormik({
    initialValues: {
      date: initialDate,
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      if (!values.date) {
        notification(
          "Error",
          "Debes seleccionar una fecha",
          "danger"
        );
        return;
      }

      setLoading(true);
      try {
        const dateISO = new Date(values.date + "T00:00:00.000Z").toISOString();
        await setDayDocumentsInit(dateISO);
        notification(
          "Éxito",
          "Día inicio documentos actualizado correctamente",
          "success"
        );
        refreshFn();
        closeFn();
      } catch (error: any) {
        notification(
          "Error",
          error?.response?.data?.message || "Error al actualizar el día inicio documentos",
          "danger"
        );
      } finally {
        setLoading(false);
      }
    },
  });

  React.useEffect(() => {
    if (initialDate) {
      formik.setFieldValue("date", initialDate);
    }
  }, [initialDate]);

  return (
    <React.Fragment>
      <div className="mb-3">
        <label htmlFor="date" className="form-label">
          Día inicio documentos
        </label>
        <input
          type="date"
          className="form-control"
          id="date"
          name="date"
          value={formik.values.date}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
        />
        {formik.touched.date && formik.errors.date && (
          <div className="text-danger small mt-1">{formik.errors.date}</div>
        )}
        <div className="form-text">
          Fecha de inicio para contar los días máximos de subida de documentos.
          Si un documento tiene por ejemplo 5 días máx., la fecha límite será esta fecha + 5 días.
        </div>
      </div>
      <div className="d-flex justify-content-end">
        <button className="btn btn-secondary me-2" onClick={() => closeFn()}>
          Cancelar
        </button>
        <button className="btn btn-azul" onClick={() => formik.handleSubmit()}>
          Actualizar
        </button>
      </div>
    </React.Fragment>
  );
};

export default EditDayDocumentsInit;
